import { FC } from 'react';
import {
  UnorderedListOutlined,
  DatabaseOutlined,
  FileOutlined,
  DollarCircleOutlined,
  BookOutlined,
} from '@ant-design/icons';
import TableFileIcon from './TableFileIcon.component';
import styles from '../NameColumn.module.scss';

interface Props {
  itemType?: string;
  filesTable?: boolean;
}

export const NameIcon: FC<Props> = ({ itemType, filesTable }) => {
  if (filesTable) {
    return <TableFileIcon fileType={itemType} />;
  }

  if (itemType === 'task') {
    return (
      <UnorderedListOutlined
        className={styles.itemIcon}
        style={{ color: '#FFFFFF', backgroundColor: 'var(--volcano-6)' }}
      />
    );
  }

  if (itemType === 'inventory') {
    return (
      <DatabaseOutlined className={styles.itemIcon} style={{ color: '#FFFFFF', backgroundColor: 'var(--gold-6)' }} />
    );
  }

  if (itemType === 'document') {
    return (
      <FileOutlined className={styles.itemIcon} style={{ color: '#FFFFFF', backgroundColor: 'var(--purple-6)' }} />
    );
  }

  if (itemType === 'logbook') {
    return <BookOutlined className={styles.itemIcon} style={{ color: '#FFFFFF', backgroundColor: 'var(--blue-6)' }} />;
  }

  return (
    <DollarCircleOutlined className={styles.itemIcon} style={{ color: '#FFFFFF', backgroundColor: 'var(--green-6)' }} />
  );
};
